/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_regionalInfo = ReadonlyArray<{
    readonly regionsByZipCode: ReadonlyArray<{
        readonly displayName: string | null;
        readonly urlLabel: string | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefetchContainer_regionalInfo";
}>;
export type SbSharedRefetchContainer_regionalInfo$data = SbSharedRefetchContainer_regionalInfo;
export type SbSharedRefetchContainer_regionalInfo$key = ReadonlyArray<{
    readonly " $data"?: SbSharedRefetchContainer_regionalInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_regionalInfo">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefetchContainer_regionalInfo",
  "type": "RegionalInfo",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "regionsByZipCode",
      "storageKey": null,
      "args": null,
      "concreteType": "RegionsByZipCode",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c3f7ac30a90500c6a81ef4813b5a69f4';
export default node;
